import type { Ref } from 'react';
import { createContext } from 'react';

export type DropdownDomStylesApplier = (
  itemElement?: HTMLElement,
  wasHiddenBefore?: boolean,
) => void;

export type DropdownContextData = {
  dropdownElementRef: Ref<HTMLDivElement | null>;
  setDropdownDomStylesApplier: (
    updateDropdownDomStyles: DropdownDomStylesApplier,
  ) => void;
};

export const DropdownContext = createContext<DropdownContextData>({
  dropdownElementRef: { current: null },
  setDropdownDomStylesApplier: () => {},
});
